(function() {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('PathManager', [
        '$q',
        'SessionManager',
        'FileService',
        'AppConstants',
        PathManager
    ]);

    function PathManager ($q, SessionManager, FileService, AppConstants) {
        var ROOT_PATH_NAME = '/',
            MAX_LENGTH = 50,
            MAX_FOLDER_LENGTH = 10,
            
            // AppConstant bindings
            viewTypes = AppConstants.ViewTypes,

            pathManager = {};
        
        /*
         * @ngdoc method
         * @name PathManager#setUploadFolderId
         *
         * @param {string} id The activeFolderId retrieved from folderState. 
         */
        pathManager.setUploadFolderId = function (id) {
            SessionManager.setUploadFolderId(id);
        };

        /*
         * @ngdoc method
         * @name PathManager#getUploadFolderId
         *
         * @returns {string} Upload folder Id.
         */
        pathManager.getUploadFolderId = function () {
            return SessionManager.getUploadFolderId();
        };

        /*
         * @ngdoc method
         * @name PathManager#setPath
         * @description This method will change the root of the path to correct label and update history in session manager
         * @param {Array} path.
         *        {Object} userInfo.
         *
         * @returns {void}
         */
        pathManager.setPath = function(path, userInfo) {
            var rootFolderId = path.Components[0].Id;

            // determine the root folder type.
            if (rootFolderId === userInfo.RootFolderId) {
                path.Components[0] = viewTypes.OWN_TYPE;
            } else if (rootFolderId === userInfo.RecycleBinFolderId) {
                path.Components[0] = viewTypes.RECYCLE_TYPE;
            } else {
                path.Components.unshift(viewTypes.SHARED_TYPE);
            }
            // update path history in session manager
            SessionManager.updateHistory(path.Components.map(function(component) {
                return component.Id?component.Id:component;
            }));                  
        };


        /* If the string exceeds maximum length, say 10, then keep maxLength - 1 characters, replace last character by ...  So "1234567890123" becomes "123456789..."*/
        function shortenFolder(folder, maxLength, removeLength) {
            if (maxLength === undefined) maxLength = MAX_FOLDER_LENGTH;
            if (folder.Name === ROOT_PATH_NAME || folder.Name.length <= maxLength) return folder;

            if (removeLength === undefined) removeLength = 1;
            return { Id : folder.Id, Name: (folder.Name.substr(0, maxLength - removeLength) + "...") };
        }

        /*
         * @ngdoc method
         * @name PathManager#clearPath
         */
        pathManager.clearPath = function () {
            SessionManager.resetPath();
        };

        return pathManager;
    }

}());
